import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AbstractComponent } from '../../shared/components/abstract-component/abstract.component';
import { TableSortModel } from '../../shared/tablesort/tableSortModel';
import { AbstractRangregelungVm } from '../../core/services/rangregelung-viewmodel.service';
import { ListLoader } from '../../shared/components/list-loader/list-loader';
import { ComparatorService } from '../../shared/services/comparator-service';
import { FormatConfigService } from '../../core/services/format-config.service';
import { keysToTranslate } from '../../../i18n/keys-to-translate';
import { DatumPipe } from '../../shared/pipes/simple/datum.pipe';
import { KompaktGrundstueckComponent } from '../../shared/kompaktdarstellung/grundstueck/kompakt-grundstueck.component';
import { KompaktStandardrechtComponent } from '../../shared/kompaktdarstellung/standardrecht/kompakt-standardrecht.component';
import { KompaktTimepointComponent } from '../../shared/kompaktdarstellung/timepoint/kompakt-timepoint.component';
import { ListLoaderWrapperComponent } from '../../shared/components/list-loader-wrapper/list-loader-wrapper.component';
import { ReadMoreComponent } from '../../shared/widgets/read-more/read-more.component';
import { TranslatePipe } from '@ngx-translate/core';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { HistoryDirective } from '../../shared/directives/history.directive';
import { KompaktBelegIcpComponent } from '../shared/component/kompakt-beleg-icp/kompakt-beleg-icp.component';
import { KompaktGrundpfandrechtIcpComponent } from '../shared/component/kompakt-grundpfandrecht-icp/kompakt-grundpfandrecht-icp.component';

@Component({
  selector: 'cap-rangregelung-table-icp',
  imports: [
    DatumPipe,
    KompaktGrundstueckComponent,
    KompaktStandardrechtComponent,
    KompaktTimepointComponent,
    ListLoaderWrapperComponent,
    ReadMoreComponent,
    TranslatePipe,
    NgClass,
    HistoryDirective,
    NgTemplateOutlet,
    KompaktBelegIcpComponent,
    KompaktGrundpfandrechtIcpComponent
  ],
  templateUrl: './rangregelung-table-icp.component.html'
})
export class RangregelungTableIcpComponent extends AbstractComponent implements OnInit, OnDestroy {
  @Input()
  hasRight = true;
  @Input()
  isEigentuemer = false;

  tableSortModel = new TableSortModel<AbstractRangregelungVm>('table', this.comparatorService);

  private changeDetectionTimeout: any;
  private _listLoader: ListLoader<AbstractRangregelungVm>;

  constructor(
    private comparatorService: ComparatorService,
    private cdr: ChangeDetectorRef,
    private appFormatConfigService: FormatConfigService
  ) {
    super();
    keysToTranslate<string>(['DatumOderBeleg']);
    this.tableSortModel.addColumn('EnstehungSort', (a, b) => this.comparatorService.lastAbstractRangregelungVm(a, b)).switchSortDirection();
  }

  ngOnInit(): void {
    this.activateChangeDetectionTrigger();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    clearTimeout(this.changeDetectionTimeout);
  }

  @Input()
  set listLoader(listLoader: ListLoader<AbstractRangregelungVm>) {
    if (!listLoader) {
      return;
    }
    this._listLoader = listLoader;
    this._listLoader.applySortModel(this.tableSortModel);
  }

  get listLoader(): ListLoader<AbstractRangregelungVm> {
    return this._listLoader;
  }

  private activateChangeDetectionTrigger() {
    this.changeDetectionTimeout = setTimeout(() => {
      this.cdr.detectChanges();
      this.activateChangeDetectionTrigger();
    }, 3000);
  }
}
